import { render, staticRenderFns } from "./ModalReference.vue?vue&type=template&id=4baff58a&"
import script from "./ModalReference.vue?vue&type=script&lang=js&"
export * from "./ModalReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports